export const LOGO_URL = "/logo.png";

export const FOUNDER_URL =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_consciousness-voice/artifacts/z6w6yx0y_B6B2B253-C2FD-437F-97E9-D989DD31F524.png";

export const WAVE_BG_URL =
  "https://images.unsplash.com/photo-1684170114111-32abdbe199cb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwzfHxhYnN0cmFjdCUyMHNvdW5kJTIwd2F2ZSUyMHNpbHZlciUyMGdvbGQlMjBkYXJrfGVufDB8fHx8MTc4ODIyNjY0NHww&ixlib=rb-4.1.0&q=85";

export const CONTACT_EMAIL = "amber@soulinlove.com";
export const MAILTO = `mailto:${CONTACT_EMAIL}`;
export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const EXPRESSIONS = [
  { path: "/soul-in-love", label: "Soul in Love" },
  { path: "/amber-ellis", label: "Amber Ellis" },
  { path: "/tundala", label: "Tundala" },
  { path: "/organizations", label: "Organizations" },
];

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: 0, duration: 1.6 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};
